import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import axiosClient from 'http/axios-client';
import * as XLSX from 'xlsx';
import { LoadingButtonNoGrid } from 'components/basic/LoadingButton';
import * as moment from 'moment';
import MonthSelector from 'components/basic/MonthSelector';
import CountrySelector from 'components/basic/CountrySelector';
import { Typography } from '@material-ui/core';
import { PDFCreationFromDBOrAmazon, getFullRegistrationStatus } from '../consents/ConsentsTable';
import '../consents/LiberationSerif-Regular-normal';
import { filterTypes } from '../../basic/AdvancedFilters';
import AppTable from '../../basic/AppTable';
import AppLoader from '../../basic/AppLoader';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

export const parseDate = (date) => {
  let deepSelectorValue = date;
  if (null != deepSelectorValue && '' !== deepSelectorValue) {
    if (10 > deepSelectorValue.length) {
      return deepSelectorValue;
    }
    if (10 !== deepSelectorValue.length) {
      deepSelectorValue = deepSelectorValue.substring(0, deepSelectorValue.indexOf('T'));
    }
    deepSelectorValue = deepSelectorValue.split('-');
    deepSelectorValue = `${ deepSelectorValue[2] }/${ deepSelectorValue[1] }/${ deepSelectorValue[0] }`;
  }

  return deepSelectorValue || '';
};

const DoctorKitsTable = () => {
  const [ month, setMonth ] = React.useState(1);
  const [ filterQuery, setFilterQuery ] = useState({});

  const [ downloadDataLoading, setDownloadDataLoading ] = useState(false);
  const [ downloadAllDataLoading, setDownloadAllDataLoading ] = useState(false);
  const [ selectLocation, setSelectLocation ] = useState({});
  const [ selectedMonths, setSelectedMonths ] = useState(1);
  const [ country, setCountry ] = useState('All');

  const handleChange = (event) => {
    const newSelectedMonths = event.target.value;
    setSelectedMonths(newSelectedMonths);
    setMonth(newSelectedMonths);
  };

  const handleLocation = (e) => {
    setSelectLocation(e.target.value);
    if (e.target.value === 'Albania') {
      setSelectLocation({ 'serial_number_id.country_eq': 'AL' });
    } else if (e.target.value === 'Greece') {
      setSelectLocation({ 'serial_number_id.country_eq': 'GR' });
    } else if (e.target.value === 'India') {
      setSelectLocation({ 'serial_number_id.country_eq': 'IN' });
    } else if (e.target.value === 'Iraq') {
      setSelectLocation({ 'serial_number_id.country_eq': 'IQ' });
    } else {
      setSelectLocation({});
      refetch();
    }
    setCountry(e.target.value);
  };

  const startDate = moment().subtract(selectedMonths, 'months').startOf('day').toISOString();

  const {
    items: kits,
    itemsLoading: kitsLoading,
    pagination,
    itemsFetching: kitsFetching,
    refetch,
  } = useItems(CollectionKeys.REGISTRATION_KITS, {
    filterQuery: {
      ...filterQuery,
      doctor_null: false,
      ...selectLocation,
    },
    queryOptions: { refetchOnWindowFocus: false },
  });
  //
  const location = useLocation();
  const history = useHistory();

  if (kitsLoading || kitsFetching) {
    return <AppLoader />;
  }

  const tableColumns = [
    { id: 1,
      label: 'Serial Number',
      field: 'serial_number_id.serial',
      customRenderer({ row }) {
        // let repeatText = 'Repeat';
        // if (row.serial_number_id.serial.includes('VR')) {
        //   repeatText = 'Updated';
        // }
        // if (null !== row.serial_number_id.ancestor) {
        //   return (
        //     <>
        //       <span>{`${ row.serial_number_id.serial?.split('_')[0] } ${ repeatText }(${ parseDate(row.created_at) })`}</span>
        //     </>
        //   );
        // }
        return (
          <span>{row.serial_number_id.serial}</span>
        );
      } },
  ];

  tableColumns.push({ id: 220,
    label: 'Report delivery date',
    field: 'report_delivery_date',
    customRenderer({ row }) {
      return (
        <>
          {parseDate(row.report_delivery_date)}
        </>
      );
    } });

  tableColumns.push({ id: 2, label: 'Doctor Last Name', field: 'doctor.family_name' });
  tableColumns.push({ id: 3, label: 'Doctor Name', field: 'doctor.name' });
  tableColumns.push({ id: 4, label: 'Registration done date', field: 'metadata.registrationDoneDate', isDate: true, noSort: true });
  tableColumns.push({ id: 5, label: 'Sample received date', field: 'metadata.sampleReceivedDate', noSort: true, isDate: true });
  tableColumns.push({ id: 3174,
    label: 'Pdf report creation date',
    field: 'pdf_creation',
    isDate: true,
    customRenderer({ row }) {
      return (
        <PDFCreationFromDBOrAmazon kit={ row } />
      );
    } });
  tableColumns.push({ id: 6, label: 'Patient Last Name', field: 'customer_id.family_name' });
  tableColumns.push({ id: 7, label: 'Patient First Name', field: 'customer_id.name' });
  tableColumns.push({ id: 8,
    label: 'Registration Status',
    field: 'registrationStatus',
    noSort: true,
    customRenderer({ row }) {
      return (
        <>
          {
            getFullRegistrationStatus(row)
          }
        </>
      );
    } });
  tableColumns.push({ id: 171559,
    label: 'Report Language',
    field: 'locale',
    customRenderer({ row }) {
      return (
        <>
          {
            3 === row?.locale ? 'en-US' : 2 === row?.locale ? 'el-GR' : '' || ''
          }
        </>
      );
    } });
  tableColumns.push({ id: 9,
    label: 'Payment Status',
    field: 'metadata.cashStatus',
    isCashStatus: true,
    noSort: true });
  tableColumns.push({ id: 10, label: 'Payment Amount', field: 'metadata.cashAmount', noSort: true });
  tableColumns.push({ id: 11, label: 'Sample collection date', field: 'metadata.sampleCollectionDate', noSort: true, isDate: true });
  // tableColumns.push({ id: 12, label: 'Description', field: 'serial_number_id.metadata.Product Description', noSort: true });
  tableColumns.push({ id: 13,
    label: 'Processing of personal data',
    noSort: true,
    customRenderer({ row }) {
      const hasConsent = row.agreements.find((aggr) => {
        return 'DOCTOR_GENERAL_CONSENT' === aggr?.consent?.name && true === aggr?.status;
      });

      return (
        <div>
          {hasConsent ? 'YES' : 'NO'}
        </div>
      );
    } });

  const downloadData = async (theFilterQuery, setShowLoader) => {
    const theKits = await axiosClient.get(CollectionKeys.REGISTRATION_KITS, {
      params: {
        ...theFilterQuery,
        ...selectLocation,
      },
    });

    if (null == theKits) {
      setShowLoader(false);
      return;
    }

    const data = await Promise.all(theKits.map(async (kit) => {
      const hasConsent = kit.agreements.find((aggr) => {
        return 'DOCTOR_GENERAL_CONSENT' === aggr?.consent?.name && true === aggr?.status;
      });

      let pdfCreation = parseDate(kit.pdf_creation);
      if ('' === pdfCreation || null == pdfCreation) {
        pdfCreation = parseDate(kit.pdf_received_date);
      }

      let pdfReceived = parseDate(kit.pdf_received_date);
      if ('' === pdfReceived || null == pdfReceived) {
        pdfReceived = parseDate(kit.pdf_received_date);
      }

      try {
        if (null != kit.serial_number_id.serial && kit.pdf_available && (null == pdfCreation || '' === pdfCreation)) {
          pdfCreation = await axiosClient.get(`/registration-kits/aws-bucket/?serial=${ kit.serial_number_id.serial }.pdf`).then((dd) => {
            return parseDate(dd.LastModified);
          });
        }
      } catch (e) {
        console.error(e);
      }

      let address = '';

      try {
        if (kit.customer_id?.address) {
          address = `${ JSON.parse(kit.customer_id.address)?.streetAddress ?? '' }, ${
            JSON.parse(kit.customer_id.address)?.city ?? '' }, ${
            JSON.parse(kit.customer_id.address)?.postalCode ?? '' }`;
        }
      } catch {
        console.error('kit id', kit.id);
      }

      if (', , ' === address) {
        address = '';
      }
      const obj = {
        'Serial Number':
        null !== kit.serial_number_id.ancestor ? `${ kit.serial_number_id.serial?.split('_')[0] })`
          : kit.serial_number_id?.serial || '',
        'Thematic Package': kit?.thematic_package?.name ?? '',
        'Report delivery date': parseDate(kit.report_delivery_date) ?? '',
        'Doctor Last Name': kit.doctor?.family_name || '',
        'Doctor First Name': kit.doctor?.name || '',
        'Doctor Email': kit.doctor?.email || '',
        'Registration done date': parseDate(kit?.metadata?.registrationDoneDate),
        'Sample received date': parseDate(kit?.metadata?.sampleReceivedDate),
        'Pdf report creation date': pdfCreation,
        'Pdf report received date': pdfReceived,

        'Patient First Name': kit.customer_id?.name || '',
        'Patient Last Name': kit.customer_id?.family_name || '',
        'Patient date of birth': kit.customer_id?.birthdate || '',
        'Patient biological gender': kit.customer_id?.gender || '',
        'Patient address': address || '',
        'Patient country': kit.customer_id?.country || '',
        'Patient email': kit.customer_id?.email || '',
        'Patient mobile number': kit.customer_id?.phone_number || '',
        'Patient landline number': kit.customer_id?.house_number || '',

        'Registration Status': getFullRegistrationStatus(kit),
        'Report language': 3 === kit?.locale ? 'en-US' : 2 === kit?.locale ? 'el-GR' : '' || '',
        'Report paid - Kit paid': `${ kit?.serial_number_id?.report_payment_status ?? 'none' } - ${ kit?.serial_number_id?.kit_payment_status ?? 'none' }`,
        'Payment Amount': kit?.metadata?.cashAmount || '',
        'Sample collection date': parseDate(kit?.metadata?.sampleCollectionDate),
        // Description: kit.serial_number_id?.metadata?.['Product Description'] || '',
        'Processing of personal data': hasConsent ? 'YES' : 'NO',
      };

      return obj;
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = fitToColumn(data);

    function fitToColumn(arrayOfArray) {
      if (!arrayOfArray[0]) { // If file is empty
        return null;
      }
      return Object.keys(arrayOfArray[0]).map((key) => {
        return { wch: key.length };
      });
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Registration Kits.xlsx');

    setDownloadDataLoading(false);
    setDownloadAllDataLoading(false);
  };

  const handleViewAction = (e, serialNumber) => {
    history.push({
      pathname: location.pathname,
      search: `?id=${ serialNumber }`,
    });
  };

  return (
    <>
      <div style={ { display: 'flex', gap: '5px', marginBottom: '15px' } }>
        <Typography
          variant='h6'
          color='secondary'
          id='location-select-label'
        >
          Country:
          {' '}
          {' '}
        </Typography>
        <div style={ { width: '150px', marginRight: '10px' } }>
          <CountrySelector
            value={ country }
            handleLocation={ handleLocation }
            all
          />
        </div>
        <LoadingButtonNoGrid
          loading={ downloadDataLoading }
          label='Download'
          onClick={ () => {
            setDownloadDataLoading(true);
            downloadData({ ...filterQuery, doctor_null: false }, setDownloadDataLoading);
          } }
          variant='contained'
          buttonStyle={ {
            marginRight: '10px',
          } }
        />

        <LoadingButtonNoGrid
          loading={ downloadAllDataLoading }
          label='Download Last'
          onClick={ () => {
            setDownloadAllDataLoading(true);
            if (selectedMonths === 'All') {
              downloadData({ _limit: -1, doctor_null: false, ...filterQuery }, setDownloadAllDataLoading, startDate);
            } else {
              downloadData({ _limit: -1, doctor_null: false, ...filterQuery, created_at_gte: startDate }, setDownloadAllDataLoading, startDate);
            }
          } }
          variant='contained'
        />

        <MonthSelector selectedMonths={ month } handleChange={ handleChange } />

      </div>
      <AppTable
        columns={ tableColumns }
        refetch={ refetch }
        data={ kits }
        loading={ kitsLoading }
        paginationProps={ pagination }
        advancedFiltersProps={ {
          properties: [
            {
              value: 'serial_number_id.serial',
              label: 'Serial Number',
              type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Doctor First Name', value: 'doctor.name', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Doctor Last Name', value: 'doctor.family_name', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Patient First Name', value: 'customer_id.name', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Patient Last Name', value: 'customer_id.family_name', type: filterTypes.FREE_TEXT,
            },
            {
              label: 'Registration Status ', value: 'registrationStatus', isRegistration: true, type: filterTypes.FREE_TEXT,
            },
            {
              value: 'thematic_package.thematic_category_id.name',
              label: 'Thematic Package',
              type: filterTypes.CATEGORY,
              options: [
                { value: '3-in-1', label: '3-in-1' },
                { value: 'Biological Age', label: 'Biological Age' },
                { value: 'Cardio Health', label: 'Cardio Health' },
                { value: 'NutriGenetix', label: 'NutriGenetix' },
                { value: 'Nutrition', label: 'Nutrition' },
                { value: 'PGx', label: 'PGx' },
                { value: 'Sports', label: 'Sports' },
                { value: 'Vitamins', label: 'Vitamins' },
              ],
            },
          ],
          initialAndFilterOptions: [],
          onQueryChange: setFilterQuery,
        } }
        ViewProp={ { handleView: handleViewAction } }
      />
    </>
  );
};

export default DoctorKitsTable;

